import { Query, SellerListBuilderPreviewInput } from '__generated__/graphql'
import { Effect, RequestResolver, pipe } from 'effect'
import { UnknownException } from 'effect/Cause'
import { SELLER_LIST_BUILDER_COUNT_QUERY } from 'features/ListBuilder/infra/repo/ListSourceRepoLive/GetBuildTotalResolver/schema'
import ListSourceRequest from 'features/ListBuilder/infra/repo/ListSourceRepoLive/ListSourceRequest'
import CriteriaSchema from 'features/ListBuilder/infra/repo/schema/CriteriaSchema'
import { apolloClient } from 'presentation/libs/client'

const GetBuildTotalResolver = RequestResolver.fromEffect(
  (request: ListSourceRequest.GetBuildTotal) => pipe(
    Effect.sync(() =>
      CriteriaSchema.toSellerListBuilderPreviewInput(request.criteria),
    ),
    Effect.flatMap(input =>
      Effect.tryPromise({
        try: async () =>
          await apolloClient.query<
            SellerListBuilderCountResponse,
            SellerListBuilderCountVariables
          >({
            query: SELLER_LIST_BUILDER_COUNT_QUERY as any,
            variables: { input },
            fetchPolicy: 'no-cache',
          }),
        catch: error => new UnknownException({ message: String(error) }),
      }),
    ),
    Effect.map(result =>
      result.data?.sellerListBuilderCount.count
      ?? result.data?.sellerListBuilderCount.estimate
      ?? 0,
    ),
    Effect.catchTag('UnknownException', v => Effect.die(v)),

  ),
)

export default GetBuildTotalResolver

type SellerListBuilderCountResponse = Pick<Query, 'sellerListBuilderCount'>
type SellerListBuilderCountVariables = {
  input: SellerListBuilderPreviewInput
}
